const userordercategoryprocess = {
    getlist: 'userordercategoryprocess/getlist',
    add: 'userordercategoryprocess/add',
    update: 'userordercategoryprocess/update',
    remove: 'userordercategoryprocess/remove',
    get: 'userordercategoryprocess/get',
    getall: 'userordercategoryprocess/getall',
    clearcache: 'userordercategoryprocess/clear-cache',
}
export default userordercategoryprocess
